import Checkbox, { CheckboxProps } from '@creditflowresearch/uilib/Checkbox';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

const CheckboxWithTooltip = ({ label, ...otherProps }: CheckboxProps) => {
  const labelWithTooltip = (
    <Tooltip content="Upgrade your plan on the Pricing page to access">
      { label }
    </Tooltip>
  );

  return <Checkbox { ...otherProps } label={ otherProps.disabled ? labelWithTooltip : label } />;
};

export default CheckboxWithTooltip;
